import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { DeltaIconComponent } from '../delta-icon/delta-icon.component';

@Component({
    selector: 'emt-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [NgClass, DeltaIconComponent],
})
export class ButtonComponent {
  @Input() text: string;
  @Input() styleType: string;
  @Input() height: number;
  @Input() width: number;
  @Input() disabled: boolean;
  @Input() showCarot = false;

  constructor() {}
}
